import { PageLoadIndicator } from "@components/site/PageLoadIndicator"
import { Header } from "@components/site/Header"
import { defineView } from "eddev/views"
import { Footer } from "@components/site/Footer"
import { CampaignPopup } from "@components/atoms/CampaignPopup"
import { FormPopup } from "@components/molecules/FormPopup"
import { ComponentPropsWithoutRef, forwardRef, useEffect } from "react"
import { ScrollRestoration, useRoute } from "eddev/routing"
import { SearchOverlay } from "@components/atoms/search/SearchOverlay"
import { useSearchSupport } from "@hooks/queries"
import { useIsMobile } from "@hooks/useViewportDerived"
import { cn } from "@utils/tw"
import { useAppData } from "eddev/hooks"
import { twMerge } from "tailwind-merge"

// fontFaceGlobalStyles()/frontendGlobalStyles() from theme.css.tsx are no
// longer called here — their content has been fully ported to
// stylesheets/fonts.scss and stylesheets/typography.scss (+ the reset in
// views/index.css). Calling both would apply overlapping/conflicting rules
// to the same elements (e.g. h1/h2 tag-based typography) with the winner
// decided by stylesheet load order rather than intent.

export default defineView("_app", (props) => {
  const route = useRoute()
  const mobile = useIsMobile()

  useEffect(() => {
    const scrollToElement = () => {
      if (route.hash) {
        setTimeout(() => {
          const element = document.getElementById(route.hash.split("#")[1])
          if (element) {
            scrollTo({
              top: element.offsetTop - 100,
              behavior: "smooth",
            })
          }
        }, 1000)
      }
    }

    scrollToElement()
    window.addEventListener("hashchange", scrollToElement)
    return () => {
      window.removeEventListener("hashchange", scrollToElement)
    }
  }, [route.pathname, route.hash])

  const enableAISearch = useAppData((data) => data?.aiSearchSettings?.settings?.enable)

  return (
    <>
      <ScrollRestoration />
      {route.pathname.includes("embed/") ? (
        <>{props.children}</>
      ) : (
        <>
          <div className="min-h-[100dvh] flex flex-col justify-between">
            <PageLoadIndicator />
            <Header />
            <div
              className={twMerge(
                "grow z-[1] overflow-y-visible flex flex-col md:pt-[96px] w-full",
                enableAISearch ? "pt-[130px]" : "pt-[74px]",
              )}
            >
              {props.children}
            </div>
            <Footer />
          </div>
          <CampaignPopup />
          {!mobile && <SearchOverlay />}
          <FormPopup fueltrack={route.pathname === "/advocacy/explainers/fuel-excise-explained/"} />
        </>
      )}
    </>
  )
})
